export class FallbackJourneyInfo {
  id: string;
  name: string;
  triggerId: string;
}
